import { render } from "./ProcessesIndex.vue?vue&type=template&id=2caf4c53&scoped=true&ts=true"
import script from "./ProcessesIndex.vue?vue&type=script&lang=ts"
export * from "./ProcessesIndex.vue?vue&type=script&lang=ts"

import "./ProcessesIndex.vue?vue&type=style&index=0&id=2caf4c53&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2caf4c53"]])

export default __exports__